import { scry_api } from './configs/axiosConfigs';
import { prepareErr, defineCancelAPIObject } from './configs/axiosUtils';
import { notifier } from '../libs/notifier';

export const scryAPI = {
	getSymbols: async function (cancel = false) {
		const url = '/symbology';

		const response = await scry_api
			.get(url, {
				signal: cancel ? cancelApiObject[this.getSymbols.name].handleRequestCancellation().signal : undefined,
			})
			.catch((error) => {
				return prepareErr(error);
			});

		if (response.status === 200) {
			return response.data.data;
		} else {
			showAPIErr(url, response?.data?.message || 'Unspecified error');
			return null;
		}
	},

	autocomplete: async function (name, cancel = false) {
		const url = `/cards/autocomplete?q=${name}`;

		const response = await scry_api
			.get(url, {
				signal: cancel ? cancelApiObject[this.autocomplete.name].handleRequestCancellation().signal : undefined,
			})
			.catch((error) => {
				return prepareErr(error);
			});

		if (response.status === 200) {
			return response.data.data;
		} else {
			showAPIErr(url, response?.data?.message || 'Unspecified error');
			return null;
		}
	},

	searchByName: async function (exactname, cancel = false) {
		const url = `/cards/named?exact=${exactname}`;

		const response = await scry_api
			.get(url, {
				signal: cancel ? cancelApiObject[this.searchByName.name].handleRequestCancellation().signal : undefined,
			})
			.catch((error) => {
				return prepareErr(error);
			});

		if (response.status === 200) {
			return response.data;
		} else {
			showAPIErr(url, response?.data?.message || 'Unspecified error');
			return null;
		}
	},

	getCardPrints: async function (scry_card, cancel = false) {
		if (!('prints_search_uri' in scry_card)) {
			return null;
		}

		const response = await scry_api
			.get(scry_card.prints_search_uri, {
				signal: cancel
					? cancelApiObject[this.getCardPrints.name].handleRequestCancellation().signal
					: undefined,
			})
			.catch((error) => {
				return prepareErr(error);
			});

		if (response.status === 200) {
			return response.data;
		} else {
			showAPIErr(scry_card.prints_search_uri, response?.data?.message || 'Unspecified error');
			return null;
		}
	},
};

// Show formatted API error
const showAPIErr = (url, message) => {
	let errMsg = 'Error in scryAPI call ' + url + ' : ' + message;
	notifier.logToConsole(notifier.level.error, errMsg, true);
};

// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelAPIObject(scryAPI);
